/*!
* Panorama Studios
*/
// Disable inital GMap3 loading
$.gmap3(false);

var translations = {
	nl: {
		rated: 'Bedankt voor uw beoordeling',
		error: 'Beoordeling opslaan mislukt'
	},
	en: {
		rated: 'Thank you for rating',
		error: 'Failed to save rating'
	},
	es: {
		rated: 'Gracias por calificar',
		error: 'Error al guardar la calificación'
	},
	zh: {
		rated: '谢谢评级',
		error: '无法保存评分'
	}
};

$(document).ready(function () {
	// Responsive nav
	$('header').each(function () {
		var element = $(this),
			responsiveNav = element.find('.responsive-nav'),
			toggler = element.find('.toggler');

		toggler.click(function () {
			responsiveNav.toggleClass('collapsed');
			$(document.body).toggleClass('nav-open');
			toggler.toggleClass('collapsed');
		}).appendTo(element);
	});

	// Open sub menu on touch or in responsive menu
	$('header .sub').each(function () {
		var element = $(this);
		element.find('> a').click(function (e) {
			if (!element.hasClass('open') && $(document).width() <= 980) {
				element.addClass('open');
				e.preventDefault();
			}
		});
	});

	// Header affix
	$('header').each(function () {
		var element = $(this);
		element.headroom({
			offset: 100
		});
		$(document.body).addClass('headroom--enabled');
	});

	// Open language on touch
	$('.languages').each(function () {
		var element = $(this)

		element.on("touchend", function (e) {
			element.toggleClass('open');
		});
	});

	// Sliders
	$('.frontpage-slider .slider').each(function () {
		var element = $(this),
			cssClass = element.attr('class');

		if (element.children('li').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				loop: true,
				auto: true,
				speed: 1000,
				pause: 4000,
				pager: false,
				item: 3,
				addClass: cssClass,
				responsive: [
					{
						breakpoint: 1300,
						settings: {
							item: 2,
							slideMove: 1
						}
					}, {
						breakpoint: 980,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				]
			});
		}
	});

	// Sliders
	$('.products .slider').each(function () {
		var element = $(this),
			cssClass = element.attr('class');

		if (element.children('div').length > 1) {
			var slider = element.lightSlider({
				slideMargin: 0,
				loop: true,
				auto: true,
				speed: 1000,
				pause: 4000,
				pager: false,
				controls: false,
				item: 7,
				addClass: cssClass,
				responsive: [
					{
						breakpoint: 1920,
						settings: {
							item: 6,
							slideMove: 1
						}
					}, {
						breakpoint: 1600,
						settings: {
							item: 5,
							slideMove: 1
						}
					}, {
						breakpoint: 1280,
						settings: {
							item: 4,
							slideMove: 1
						}
					}, {
						breakpoint: 1024,
						settings: {
							item: 3,
							slideMove: 1
						}
					}, {
						breakpoint: 750,
						settings: {
							item: 2,
							slideMove: 1
						}
					}, {
						breakpoint: 550,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				]
			});

			$('.products .slider-wrapper').each(function () {
				var wrapper = $(this);
				wrapper.append('<div class="lSAction"><a class="lSPrev"></a><a class="lSNext"></a></div>');
				wrapper.find('.lSPrev').click(function () {
					slider.goToPrevSlide();
				});
				wrapper.find('.lSNext').click(function () {
					slider.goToNextSlide();
				});
			});
		}
	});

	$('.images.slider').each(function () {
		var element = $(this),
			cssClass = element.attr('class');

		if (element.children('li').length > 1) {
			element.lightSlider({
				slideMargin: 0,
				autoWidth: true,
				loop: true,
				auto: true,
				speed: 1000,
				pause: 4000,
				pager: false,
				item: 3,
				addClass: cssClass,
				responsive: [
					{
						breakpoint: 1300,
						settings: {
							item: 2,
							slideMove: 1
						}
					}, {
						breakpoint: 980,
						settings: {
							item: 1,
							slideMove: 1
						}
					}
				]
			});
		}
	});

	// Slideshows
	$('.slideshow').each(function () {
		var element = $(this);
		if (element.children('li').length > 1) {
			element.lightSlider({
				item: 1,
				addClass: element.attr('class'),
				mode: 'fade',
				speed: 1000,
				auto: element.hasClass('header'),
				loop: true,
				pause: 5000,
				controls: false
			});
		}
	});

	// Count up plant total
	$('.types-amount').each(function () {
		var element = $(this),
			value = parseInt(element.text());

		if (value > 3) {
			var start = Math.round(value * 0.6);
			var countUp = new CountUp(this, start, value);
			countUp.start();
		}
	});

	// Search typeahead
	var typeaheads = $('header .search input[type=text]').typeahead(null, {
		name: 'search',
		limit: 10,
		source: new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.whitespace,
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			prefetch: {
				url: (window.baseUrl || '/') + 'Services/Search.asmx/GetProducts?cultureName=' + document.documentElement.lang,
				//cache: false,
				ttl: 3600000 // 1 hour
			}
		})
	});
	$('#content .filter .product-name input[type=text]').each(function () {
		var id = $('#content .filter').data('id');
		if (id) {
			typeaheads = typeaheads.add($(this).typeahead(null, {
				name: 'filter',
				limit: 5,
				source: new Bloodhound({
					datumTokenizer: Bloodhound.tokenizers.whitespace,
					queryTokenizer: Bloodhound.tokenizers.whitespace,
					prefetch: {
						url: (window.baseUrl || '/') + 'Services/Search.asmx/GetCategoryProducts?cultureName=' + document.documentElement.lang + '&categoryId=' + id,
						//cache: false,
						ttl: 3600000 // 1 hour
					}
				})
			}));
		}
	});
	$(typeaheads).on('typeahead:select', function (e, value, dataset) {
		// Auto submit search form
		$(this).closest('.search').find('[type=submit]').click();
	}).attr('autocomplete', 'off');

	// Rating controls
	$('.rate .rating').each(function () {
		var element = $(this),
			id = element.attr('data-id'),
			parent = $('p.rate'),
			//parent = element.parent().parent(),
			status = parent.find('span.status'),
			url = (window.baseUrl || '/') + 'Services/Rate.asmx/AddRating',
			translation = translations[document.documentElement.lang] || translations[document.documentElement.lang.substring(0, 2)];

		// Add list
		var list = $('<ol>', {
			'class': element.attr('class')
		}).append($.map([1, 2, 3, 4, 5], function (i) {
			return $('<li>', {
				'class': 'r' + i
			}).append($('<a>', {
				text: i,
				on: {
					click: function () {
						var currentClass = list.attr('class');
						list.attr('class', 'rating r' + i);

						parent.addClass('loading');
						status.text('');

						$.post(url, {
							id: id,
							rating: i
						}, function (data) {
							console.log(data);
							parent.removeClass('loading');
							setTimeout(function () {
								status.text(translation.rated);
							}, 500);
						}).fail(function () {
							parent.addClass('error');
							setTimeout(function () {
								status.text(translation.error);
							}, 500);
							element.attr('class', currentClass);
						}).always(function () {
							setTimeout(function () {
								parent.removeClass('loading');
							}, 500);
						});
					}
				}
			}));
		}));
		element.replaceWith(list);
	});

	// Product type accordion
	$('.product-type').each(function () {
		var article = $(this),
			title = article.children('.title'),
			content = article.children('.types'),
			hidden = true;

		content.hide();

		title.click(function () {
			if (hidden) content.slideDown(300);
			else content.slideUp(300);

			hidden = !hidden;

			if (!hidden) article.addClass('open');
			else article.removeClass('open');
		});
	});

	// Lightbox
	$('#container').lightGallery({
		selector: '.lightbox, [rel=lightbox]',
		download: false,
		thumbnail: false,
		fullScreen: false
	});

	$('.video-lightbox').lightGallery({
		download: false,
		thumbnail: false,
		fullScreen: false
	});

	// Filter collapse
	$('.filter').each(function () {
		var element = $(this),
			container = element.next();

		element.append($('<span class="collapser">Collapse</span>').click(function () {
			element.toggleClass('collapsed');
			container.toggleClass('full-width');
		}));
	});

	// Filter selectize
	$('.flower-type select').selectize({
		plugins: ['remove_button'],
		sortField: 'text'
	});

	// Agent search selectize
	$('.agent-search').each(function () {
		var element = $(this).find('select');
		var searchBox = element.selectize({
			sortField: 'text'
		});

		searchBox.on('change', function () {
			var href = $('.agent-search .item').attr('data-value');
			if (href) document.location.href = href;
		});

		$(this).next('.button').addClass('hidden');
	});

	// Infinite paging
	$('.product-container').each(function () {
		var overview = $(this);
		var pager = overview.find('.pager');

		if (pager) {
			pager.appendTo(overview);
			overview.contents().wrapAll('<div class="jscroll-inner" />');
			var pagerLink = pager.find('a');
			pagerLink.one('click', function (e) {
				// Create loading pager
				var loading = $('<div>').append(pager.clone().addClass('loading'));
				loading.find('a').text(pagerLink.data('loading-text')).attr('href', null);

				// Add infinite scrolling
				overview.jscroll({
					loadingHtml: loading.html(),
					padding: 600,
					nextSelector: '.pager a:last',
					pagingSelector: '.pager'
				});

				// Trigger scroll event, so next page is directly loaded
				$(window).trigger('scroll');

				// Do not follow link
				e.preventDefault();
			});
		}
	});

	// FAQ
	$('.faq-article').each(function () {

		var article = $(this),
			title = article.children('h3'),
			content = article.children('.content'),
			hidden = true;

		content.hide();

		title.click(function () {
			if (hidden) content.slideDown(300)
			else content.slideUp(300);

			hidden = !hidden;

			if (!hidden) article.addClass('open')
			else article.removeClass('open');
		});
	});

	var newsToastData = aspJsVars['newsToastData'];
	if (newsToastData) {
		// Set options
		toastr.options = {
			progressBar: true,
			closeButton: true,
			newestOnTop: false,
			timeOut: 10000,
			extendedTimeOut: 10000,
			showDuration: 0,
			target: 'header',
			iconClasses: {
				info: 'news'
			},
			titleClass: 'title',
			messageClass: 'date'
		};

		var cookieName = 'newsToast',
			ignoredIds = Cookies.get(cookieName);

		var ignoreId = function (id) {
			if (ignoredIds) ignoredIds += ',' + id;
			else ignoredIds = id;

			Cookies.set(cookieName, ignoredIds);
		};

		$.each($.parseJSON(newsToastData), function () {
			var data = this;

			if (data.button.length > 0) {
				data.name += '<br /><span class="button">' + data.button + '</span>';
			}

			toastr.info(data.date, data.name, {
				onHidden: function () {
					// Add id to cookie
					ignoreId(data.id);
				}
			}).on({
				click: function () {
					// Add id to cookie and go to URL
					ignoreId(data.id);
					document.location = data.url;
				}
			});
		});
	}

	// Toastr
	var toastData = aspJsVars['toastData'];
	if (toastData) {
		// Set options
		toastr.options = {
			progressBar: true,
			closeButton: true,
			newestOnTop: false,
			timeOut: 10000,
			extendedTimeOut: 10000,
			showDuration: 0,
			target: 'header',
			iconClasses: {
				info: 'happening'
			},
			titleClass: 'title',
			messageClass: 'date'
		};

		var cookieName = 'toast',
			ignoredIds = Cookies.get(cookieName);

		var ignoreId = function (id) {
			if (ignoredIds) ignoredIds += ',' + id;
			else ignoredIds = id;

			Cookies.set(cookieName, ignoredIds);
		};

		$.each($.parseJSON(toastData), function () {
			var data = this;

			if (data.button.length > 0) {
				data.date += '<br /><span class="button">' + data.button + '</span>';
			}

			toastr.info(data.date, data.name, {
				onHidden: function () {
					// Add id to cookie
					ignoreId(data.id);
				}
			}).on({
				click: function () {
					// Add id to cookie and go to URL
					ignoreId(data.id);
					document.location = data.url;
				}
			});
		});
	}

	// Convert tables to charts
	$.extend(true, Chart.defaults, {
		global: {
			responsive: true,
			responsiveAnimationDuration: 0.0001,
			maintainAspectRatio: false,
			defaultColor: '#002458',
			defaultFontColor: '#002458',
			defaultFontFamily: '"Titillium Text", Verdana, Geneva, sans-serif',
			defaultFontSize: 16,
			title: {
				display: false
			},
			legend: {
				labels: {
					boxWidth: 16,
					padding: 20
				}
			},
			tooltips: {
				mode: 'label',
				backgroundColor: '#fff',
				titleFontSize: 0,
				titleSpacing: 0,
				bodySpacing: 10,
				bodyFontColor: '#002458',
				titleMarginTop: 0,
				titleMarginBottom: 0,
				xPadding: 20,
				yPadding: 20,
				caretSize: 10,
				cornerRadius: 4,
				callbacks: {
					label: function (tooltipItem, data) {
						return ' ' + data.datasets[tooltipItem.datasetIndex].label + ': ' + (tooltipItem.yLabel !== null && !isNaN(tooltipItem.yLabel) ? tooltipItem.yLabel : 'n/a');
					}
				}
			},
			elements: {
				line: {
					tension: 0,
					fill: false
				},
				point: {
					hitRadius: 10
				}
			},
			datasets: [{
				borderColor: '#99a7bc',
				backgroundColor: '#99a7bc'
			}, {
				borderColor: '#002458',
				backgroundColor: '#002458'
			}, {
				borderColor: '#cbd401',
				backgroundColor: '#cbd401'
			}],
			animation: {
				onProgress: function (options) {
					var chartInstance = this.chart,
						ctx = chartInstance.ctx;
					ctx.textAlign = 'center';

					Chart.helpers.each(this.data.datasets, function (dataset, i) {
						var meta = chartInstance.controller.getDatasetMeta(i);
						Chart.helpers.each(meta.data, function (metaData, index) {
							var value = dataset.data[index],
								width = ctx.measureText(value).width + 10,
								x = metaData._model.x,
								y = metaData._model.y - 28;

							ctx.strokeStyle = '#002458';
							ctx.lineWidth = 1;
							ctx.strokeRect(x - width / 2, y - 6, width, 24);
							ctx.fillStyle = '#fff';
							ctx.fillRect(x - width / 2, y - 6, width, 24);
							ctx.fillStyle = '#002458';
							ctx.fillText(value, x, y);
						});
					});
				}
			}
		},
		scale: {
			gridLines: {
				color: '#bec7d4'
			},
			ticks: {
				beginAtZero: true,
				padding: 40
			}
		}
	});

	$('.product table.testresults').tableToChart({
		chartOptions: {
			tooltips: {
				mode: 'label'
			},
			scales: {
				yAxes: [{
					// Forcing time in days
					id: 'y-axis-0',
					type: 'linear',
					ticks: {
						display: false,
						suggestedMax: 150
					}
				}, {
					// Stem length in cm
					id: 'y-axis-1',
					type: 'linear',
					display: false,
					ticks: {
						suggestedMax: 250
					},
					gridLines: {
						zeroLineWidth: 0
					}
				}, {
					// Amount of bulbs
					id: 'y-axis-2',
					type: 'linear',
					display: false,
					ticks: {
						suggestedMax: 12
					},
					gridLines: {
						zeroLineWidth: 0
					}
				}]
			}
		}
	});

	$('.product table.acreages').tableToChart({
		chartOptions: {
			tooltips: {
				enabled: false
			},
			scales: {
				yAxes: [{
					// Acreages in ha
					id: 'y-axis-0',
					type: 'linear',
					ticks: {
						display: false
					},
					gridLines: {
						zeroLineWidth: 0
					}
				}]
			}
		}
	});

	// Smooth scroll
	$('a[href^="#"]').click(function () {
		var target = $(this.hash);
		if (!target.length) {
			target: $('[name=' + this.hash.slice(1) + ']');
		}
		if (target.length) {
			$('html, body').animate({
				scrollTop: target.offset().top - $('header').outerHeight() - $('.responsive-nav').outerHeight()
			}, 500);

			return false;
		}
	});

	// Test results table
	$('table.testresults.all').DataTable({
		dom: 'rtp',
		info: false,
		//paging: false,
		pageLength: 20,
		pagingType: 'numbers',
		responsive: true,
		orderClasses: false,
		order: [[2, 'asc']],
		columnDefs: [{
			targets: [0, 1],
			visible: false
		}, {
			targets: [2],
			type: 'html'
		}, {
			targets: [3, 6],
			type: 'natural'
		}, {
			targets: [4, 5],
			type: 'num'
		}],
		initComplete: function () {
			// Add filter
			var search = $('<div class="select form">');
			this.api().columns([0, 1]).every(function () {
				var column = this;
				var p = $('<p>');
				var label = $('<label>').text($(column.header()).text()).appendTo(p);
				var select = $('<select>').append($.map(column.data().unique().sort().reverse(), function (d) {
					return $('<option>').text(d);
				})).appendTo(p).on('change', function () {
					var val = $.fn.dataTable.util.escapeRegex($(this).val());
					column.search(val ? '^' + val + '$' : '', true, false).draw();
				}).trigger('change');

				search.append(p);
			});
			this.api().columns(2).every(function () {
				var column = this;
				var p = $('<p>');
				var label = $('<label>').text($(column.header()).text()).appendTo(p);
				var select = $('<input type="text">').appendTo(p).on('keyup', function () {
					column.search($(this).val()).draw();
				});

				search.append(p);
			});
			search.insertBefore(this);
		}
	});

	// Change target for external sites
	var getDomainName = function (hostName) {
		return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
	};
	$('a:not([target])').filter(function () {
		var link = $(this);

		if (link.filter('[rel~="external"]').length) return true; // Link rel attribute contains 'external'

		var href = link.attr('href');
		if (new RegExp('\.pdf$', 'i').test(href)) return true; // Link to PDF file

		if (new RegExp('^https?://', 'i').test(href)) {
			var linkHostName = getDomainName(href.substring(href.indexOf('/') + 2, href.indexOf('/', 8)));
			if (!new RegExp('(^|\.)' + getDomainName(document.location.hostname) + '$', 'i').test(linkHostName)) {
				// Link is to different domain name
				return true;
			}
		}

		return false;
	}).attr('target', '_blank');

	// Google maps
	var maps = $('figure.google-maps');
	if (maps.length) {
		// Load Google Maps API once
		$.ajaxSetup({
			cache: true
		});

		// Load the script and add the api key
		$.getScript('https://maps.google.com/maps/api/js?sensor=false' + (aspJsVars['MapsApiKey'] ? '&key=' + aspJsVars['MapsApiKey'] : ''), function () {
			maps.each(function () {
				// Create map
				var map = $(this).addClass('activated');

				// Split the markers
				var markers = map.children('img')[0].src.split('&markers=');

				// Convert values to JSON Markup
				var values = JSON.parse('{"' + decodeURI(markers.shift().split('?')[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');

				// Get center
				var center = new google.maps.LatLng(values.center.split('%2c')[0], values.center.split('%2c')[1]);

				// Get map type
				var mapType = google.maps.MapTypeId.ROADMAP;
				if (values.maptype === 'satellite') {
					mapType = google.maps.MapTypeId.SATELLITE;
				}

				// Convert the markers for Gmap use
				jQuery.each(markers, function (i, marker) {
					var markerValues = marker.split('%7C');
					var position = markerValues.pop().split('%2c');
					markerValues = JSON.parse('{"' + markerValues.join('","').replace(/:/g, '":"') + '"}');

					var url = (window.baseUrl || '/') + 'images/';
					var anchor = new google.maps.Point(16, 32);
					var scaledSize = new google.maps.Size(32, 32);

					// Get icon options based on label
					switch (markerValues.label) {
						case '0':
							url += 'building.png';
							break;
						case '1':
							url += 'peoples.png';
							break;
						case '2':
							url += 'flowers.png';
							break;
						default:
							url += 'marker-sprite.png';
							anchor = new google.maps.Point(37, 81);
							scaledSize = new google.maps.Size(74, 91);
							break;
					}

					markers[i] = {
						position: position,
						icon: {
							url: url,
							anchor: anchor,
							scaledSize: scaledSize
						},
						clickable: false
					};
				});

				// Render the google maps
				map.gmap3({
					center: center,
					mapTypeId: mapType,
					zoom: parseInt(values.zoom),
					minZoom: 2,
					maxZoom: 17,
					scrollwheel: false,
					zoomControl: true,
					zoomControlOptions: {
						position: 4,
						style: 0
					},
					mapTypeControl: true
				})
				// Add the markers
				.marker(markers);
			});
		});
	}
});